import { Box } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import WarningIcon from "@mui/icons-material/Warning";
import CancelIcon from "@mui/icons-material/Cancel";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { MetricsInstallments } from "./Components/MetricsInstallments";
import { TableAnaliseInstallments } from "./Components/TableAnaliseInstallments";
import { useContextParcelas } from "src/Contexts/Parcelas/ParcelasContext";

interface MetricCard {
  title: string;
  value: string;
  icon: React.ReactNode;
  backgroundColor: string;
  iconColor: string;
  textColor: string;
}

export const TotalInstallments = {
  title: "Total",
  value: "4",
  icon: <DescriptionIcon />,
  backgroundColor: "#f5f5f5",
  iconColor: "#666666",
  textColor: "#333333",
}

interface IAnaliseInstallments {
  step: number;
  setStep: (step: number) => void;
}

export const AnaliseInstallments = ({ step, setStep }: IAnaliseInstallments) => {
  const { listUploadInstallments } = useContextParcelas();

  const metrics: MetricCard[] = [

    {
      title: "Correspondentes",
      value: "1",
      icon: <CheckCircleIcon />,
      backgroundColor: "#e8f5e9",
      iconColor: "#4caf50",
      textColor: "#2e7d32",
    },
    {
      title: "Novas",
      value: "1",
      icon: <AddCircleIcon />,
      backgroundColor: "#e3f2fd",
      iconColor: "#2196f3",
      textColor: "#1976d2",
    },
    {
      title: "Novas Divergentes",
      value: "1",
      icon: <WarningIcon />,
      backgroundColor: "#fff3e0",
      iconColor: "#ff9800",
      textColor: "#f57c00",
    },
    {
      title: "Não Encontradas",
      value: "1",
      icon: <CancelIcon />,
      backgroundColor: "#ffebee",
      iconColor: "#f44336",
      textColor: "#c62828",
    },
    {
      title: "Valor Total",
      value: "R$ 1.577,43",
      icon: <TrendingUpIcon />,
      backgroundColor: "#f3e5f5",
      iconColor: "#9c27b0",
      textColor: "#7b1fa2",
    },
    {
      title: "Total Comissão",
      value: "R$ 47,32",
      icon: <RemoveCircleIcon />,
      backgroundColor: "#e0f2f1",
      iconColor: "#009688",
      textColor: "#00695c",
    },
  ];

  return (
    <Box >
      <MetricsInstallments metrics={metrics} total={listUploadInstallments.data.length} />

      <TableAnaliseInstallments step={step} setStep={setStep} data={listUploadInstallments.data} />
    </Box>
  );
};